//import package in root model
import { BrowserModule } from '@angular/platform-browser'; //include model
import { NgModule } from '@angular/core'  // inport anfular code
import { RouterModule } from '@angular/router'; // import module 
import { HttpModule } from '@angular/http'; //import http module
import { DatePipe, CommonModule } from '@angular/common';

//import routing module
import { AppComponent } from './app.component'; //import main module
//import { AplicationComponent } from './component/aplication/aplication.component'; //import home module


//importing services for root module
import { AuthService } from './services/auth.service'; //import service for auth
import { MessageService } from './services/message.service'; //import service for message
import { PagerService } from './services/index';

//import resolver
import { LoginResolve } from './app.resolve';
import { GlobalService } from './services/global.service';
import { ErrorComponent } from './component/shared/error_component/error.component';
import { SharedModule } from './component/shared/shared.module';
import { GlobalProvider } from "./globalProvider";

import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http'; 

@NgModule({
  declarations: [
    AppComponent,
    //AplicationComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule.withServerTransition({appId: 'my-app'}),
    CommonModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'login', pathMatch: 'full' }, //redirect / to login page
      { path: 'forget_password', loadChildren: './component/aplication/password/forget/forget_password.module#AdminForgetPasswordModule'}, 
      { path: 'reset_password/:id', loadChildren: './component/aplication/password/reset/reset_password.module#AdminResetPasswordModule'}, 
      { path: 'login', loadChildren: './component/login/login.module#LoginModule'}, //for aplication login module
      { path: 'admin', loadChildren: './component/aplication/aplication.module#AplicationModule'
      }, //for aplication module
      { path: 'courseformat_editor', loadChildren: './component/aplication/aplication.module#AplicationModule'
      }, //for aplication module
      { path: 'customer', loadChildren: './component/customer/customer.module#CustomerModule'
      }, //for customer module
      { path: 'student', loadChildren: './component/student/base.module#BaseModule' }, //for student module
      { path: 'error', component: ErrorComponent }
      //{ path: 'job', loadChildren: './public/job/job.module#EventModule'}
    ]),
    HttpModule,
    HttpClientModule
  ],
  providers: [
    AuthService,
    GlobalService,
    MessageService,
    PagerService,
    LoginResolve,
    GlobalProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts